import * as actionTypes from '../actions/ActionTypes';
import { Login, setPurchaseStatus, startLoading, stopLoading } from '../actions/CommonActions';

import { canShowForgotPassWordModel } from '../actions/LoginActions';

import * as api from '../../shared/services/api/apiAuth';

// import { goto_flash } from "../../Navigation/actions";
import { all, put, takeEvery } from 'redux-saga/effects';
import { checkOffline } from '../../shared/services/Utility';

function* loginAuthentication({ type, loginBody, callback }) {
  try {
    yield put(startLoading());
    const data = yield api.loginAuthentication(loginBody);

    if (data.status === 1) {

      yield put(Login(data.userId, data.emailId, data.sessionToken));

      let purcahseStatus = yield api.getPurchaseStatus_API({
        userId: data.userId,
        sessionToken: data.sessionToken,
      });

      if (purcahseStatus && purcahseStatus.paymentStatus) {
        yield put(setPurchaseStatus(purcahseStatus.paymentStatus));
      }

      callback('Login successful', 'success');
    } else {
      // alert(data.message);
      callback(data.message, 'info');
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      callback('You are offline.', 'error');
    } else {
      callback('Something went wrong.', 'error');
    }
  }
}

function* sendingPasswordOnEmail({ type, emailId, callback }) {

  try {
    yield put(startLoading());
    const data = yield api.sendingPasswordOnEmail(emailId);

    if (data.status === 1) {
      yield put(canShowForgotPassWordModel(false, data.message));
      yield put(stopLoading());
      callback(false, '');
    } else {
      if (data.status === 0) {
        callback(true, 'Email does not exist.');
      } else {
        callback(true, data.message);
      }
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    callback(true, 'Something went wrong.');
  }
}

function* loginSaga() {
  yield all([
    takeEvery(actionTypes.LOGIN_REQUEST, loginAuthentication),
    takeEvery(actionTypes.FORGET_PASSWORD_REQUEST, sendingPasswordOnEmail),
  ]);
}

export default loginSaga;
